import React, { useEffect, useState, createElement, Component } from 'react';
import { motion, AnimatePresence, useScroll, useMotionValueEvent } from 'framer-motion';
import { Star, Heart, MessageCircle, CheckCircle2, CreditCard, Users, Ticket, ChevronRight, X, Shield, Calendar, Infinity as InfinityIcon, Handshake, ChevronDown, HelpCircle, Camera, Scissors, Ruler, Circle, Flower2, Wind } from 'lucide-react';
// --- Constants & Data ---
const CHECKOUT_LINK = 'https://primex-digital.shop/cart/45245694574701:1';
const COMBO_CHECKOUT_LINK = 'https://primex-digital.shop/cart/45245472964717:1';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/2SoAtef4NiCor3Zs6PDdC7/ChatGPT_Image_11_may_2026,_19_54_50.webp';
const HERO_BG = 'https://cdn.magicpatterns.com/uploads/hyRjcsCfC9oubUGBy62xij/sacame_el_titulo_202604231454.jpg';
const PROJECTS = [{
  url: 'https://cdn.magicpatterns.com/uploads/pMWq4JR7FnjaSZZU2446tR/5158e4e59a7d042ea5975afe651f836c.webp',
  title: 'Accesorios para Bebé',
  comment: 'Ternura en cada puntada para los momentos que más importan.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/1AmhZCg4JuGVvYDXcfopVZ/135fe2964978e887e20de89fee426b24.webp',
  title: 'Primeras Prendas',
  comment: 'Un abrazo de tela hecho con paciencia y dedicación.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/sAbf5ScvvtYPZDBfoNMeMv/840fca2308241e19189d5b1848b95db7.webp',
  title: 'Costura con Técnica',
  comment: 'La satisfacción de ver cómo un trazo se convierte en realidad.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/hnTur4po3AyrVuevgCsmNY/51a6773011984814d911793d1a0dd987.webp',
  title: 'Textiles de Hogar',
  comment: 'Creando espacios que invitan a compartir y disfrutar.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/tgRAsveZeZCAjsFv6mWjQk/8871b7fd9beeaf4e66ecc15a9520134d.webp',
  title: 'Diseños con Alma',
  comment: 'Tu creatividad plasmada en prendas que inspiran a crear.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/b74duinN94Cjb7K7YLY1QM/9e2346c3b3b1fcc362b24abd16d4421b.webp',
  title: 'Blusa Romántica en Lino',
  comment: 'La elegancia de lo simple, capturada en una prenda que trasciende temporadas.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/pV4sKDP642VaPF2pH8NRNN/73ab0ccb727afdda53cecada3b9338f0.webp',
  title: 'Set de Bienvenida Fox',
  comment: 'Preparando el nido con amor y las telas más suaves para la piel del bebé.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/3ktAe5fsrSzeyvDW6wRxXo/6c50b2bbaa813db148fe63e0e4e316fc.webp',
  title: 'Mesa con Estilo Atelier',
  comment: 'Detalles que transforman lo cotidiano en una experiencia gourmet en casa.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/gYr1rXhjHdNXrRqycmtTqg/6d668eba2062c5dd18c7704c336b4515.webp',
  title: "Abrigo de Lluvia 'Paws'",
  comment: 'Porque ellos también merecen lucir impecables mientras exploran el mundo.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/w25NbnBVKBU1NuhbknDdW6/11e2e0b67ec4ed77f370028a35110a31.webp',
  title: 'El Arte del Calce Perfecto',
  comment: 'Dominar el denim es el paso final para convertirte en una experta de la moda.'
}];
const BONUSES = [{
  id: 1,
  title: 'BONO #1 - ATELIER DE CREACIÓN',
  desc: '+2000 Moldes Profesionales en todas las tallas and categorías. Una biblioteca infinita de posibilidades para que nunca te falte inspiración ni proyectos por crear.',
  img: 'https://cdn.magicpatterns.com/uploads/ru5vELTfC8PkEJbBEvS8qm/ChatGPT_Image_27_may_2026,_21_09_40.webp'
}, {
  id: 2,
  title: 'BONO #2 - HOGAR CON ALMA',
  desc: 'Proyectos creativos para decorar, organizar y transformar tu hogar. Aprende a crear espacios acogedores y llenos de inspiración femenina con tus propias manos.',
  img: 'https://cdn.magicpatterns.com/uploads/unwuwjatb3kRLwqJPs54Vs/ChatGPT_Image_27_may_2026,_21_11_44.png'
}, {
  id: 3,
  title: 'BONO #3 - TU MARCA TEXTIL',
  desc: 'Kit completo de branding, etiquetas y catálogo para emprendedoras textiles. Todo lo que necesitas para proyectar una imagen profesional y empezar a vender tus creaciones.',
  img: 'https://cdn.magicpatterns.com/uploads/kJaciTwKY5rkcHHcoHXxvz/ChatGPT_Image_27_may_2026,_21_13_41.webp'
}, {
  id: 4,
  title: 'BONO #4 - COSTURA DESDE CERO',
  desc: 'Aprende paso a paso los fundamentos de la costura desde nivel principiante. Pierde el miedo a la máquina y domina las técnicas básicas con total confianza y calma.',
  img: 'https://cdn.magicpatterns.com/uploads/4m7tmnDLPyhsvggmdxsfcP/ChatGPT_Image_29_may_2026,_16_51_51.webp'
}];
const TESTIMONIALS = [{
  name: 'Marta G.',
  text: 'No puedo creer lo que estoy viendo, los moldes son clarísimos. Antes me volvía loca con los tutoriales de YouTube que no explicaban bien. ¡Mil gracias!',
  rating: 5
}, {
  name: 'Silvia de Cordoba',
  text: 'Lo compré ayer y ya terminé mi primer vestido. Quedó divino, calza perfecto. Valió cada peso invertido.',
  rating: 5
}, {
  name: 'Graciela',
  text: 'Al principio dudaba por el miedo a no saber usar la máquina, pero la verdad que la pedagogía es otra cosa. Se nota que enseñan con amor.',
  rating: 4
}, {
  name: 'Mirta R.',
  text: 'Estaba cansada de descoser todo el tiempo. Con Alma Textil por fin me sale todo a la primera. ¡Re contenta y motivada!',
  rating: 5
}, {
  name: 'Elena',
  text: 'Muy bueno todo, los bonos son geniales. El de Tu Marca Textil me dio el empujón para empezar a vender.',
  rating: 5
}];
const ARG_CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén'];
const NAMES = ['Maria', 'Ana', 'Juana', 'Beatriz', 'Graciela', 'Marta', 'Silvia', 'Elena', 'Patricia', 'Rosa', 'Sofía', 'Camila', 'Rocío', 'Valentina', 'Julieta', 'Micaela', 'Florencia', 'Agustina', 'Daniela', 'Carolina', 'Lucía', 'Martina'];
// --- Top Bar Activity Component ---
const TopBarActivity = ({
  showPurchase,
  currentMessage
}: {
  showPurchase: boolean;
  currentMessage: string;
}) => {
  return <div className="w-full flex items-center justify-start sm:justify-center min-h-[40px]" data-id="element-0">
      <AnimatePresence mode="wait" data-id="element-1">
        {showPurchase ? <motion.div key="purchase" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} className="text-[#2F5233] font-bold text-xs sm:text-sm text-left sm:text-center px-2 flex items-center gap-2" data-id="element-2">
            {currentMessage}
          </motion.div> : <motion.div key="counter" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} className="flex items-center gap-2" data-id="element-3">
            <span className="text-[#2F5233] uppercase tracking-wider text-[10px] font-black pr-[22px] pl-[22px]" data-id="element-4">
              29 DE MAYO OFERTA ·
            </span>
            <CountdownTimer data-id="element-5" />
          </motion.div>}
      </AnimatePresence>
    </div>;
};
// --- Countdown Timer Component ---
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState<{
    minutes: number;
    seconds: number;
  } | null>(null);
  useEffect(() => {
    const STORAGE_KEY = 'hilos_enamoran_timer_end';
    const FIFTEEN_MINUTES = 15 * 60 * 1000;
    const getEndTime = () => {
      let stored = localStorage.getItem(STORAGE_KEY);
      const now = Date.now();
      if (!stored || isNaN(parseInt(stored)) || now > parseInt(stored)) {
        const newEnd = now + FIFTEEN_MINUTES;
        localStorage.setItem(STORAGE_KEY, newEnd.toString());
        return newEnd;
      }
      return parseInt(stored);
    };
    let endTime = getEndTime();
    const updateTimer = () => {
      const now = Date.now();
      const difference = endTime - now;
      if (difference <= 0) {
        endTime = now + FIFTEEN_MINUTES;
        localStorage.setItem(STORAGE_KEY, endTime.toString());
      }
      const minutes = Math.floor(Math.max(0, difference) / 1000 / 60 % 60);
      const seconds = Math.floor(Math.max(0, difference) / 1000 % 60);
      setTimeLeft({
        minutes,
        seconds
      });
    };
    // Initial call
    updateTimer();
    const timer = setInterval(updateTimer, 1000);
    return () => clearInterval(timer);
  }, []);
  if (!timeLeft) return null;
  return <div className="flex items-center gap-1" data-id="element-6">
      <span className="font-black tabular-nums text-[#2F5233] text-[14px] ml-[0px]" data-id="element-7">
        {timeLeft.minutes.toString().padStart(2, '0')}:
        {timeLeft.seconds.toString().padStart(2, '0')}
      </span>
    </div>;
};
// --- Custom Icons ---
const YarnBallIcon = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-8">
    <circle cx="12" cy="12" r="10" data-id="element-9" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10" data-id="element-10" />
    <path d="M12 2a15.3 15.3 0 0 0-4 10 15.3 15.3 0 0 0 4 10" data-id="element-11" />
    <path d="M2 12h20" data-id="element-12" />
    <path d="M12 2v20" data-id="element-13" />
    <path d="M7 7l10 10" data-id="element-14" />
    <path d="M7 17L17 7" data-id="element-15" />
  </svg>;
const PremiumCTAButton = ({
  onClick,
  className = ''
}: {
  onClick: () => void;
  className?: string;
}) => <motion.button onClick={onClick} whileHover={{
  scale: 1.03,
  brightness: 1.1
}} whileTap={{
  scale: 0.97
}} className={`${`relative group flex flex-col items-center justify-center bg-gradient-to-br from-[#fdf2f2] via-[#E07A5F] to-[#D1694E] text-white rounded-[2.5rem] shadow-[0_15px_35px_rgba(224,122,95,0.3)] border border-[#D4AF37]/40 overflow-hidden transition-all duration-500 animate-float-slow animate-shine-slow ${className}`} pt-[2px] pb-[2px] pl-[2px] mt-[00px] mb-[0px] ml-[0px]`} data-id="element-16">
    {/* Glossy overlay */}
    <div className="absolute inset-0 bg-gradient-to-b from-white/20 to-transparent pointer-events-none" data-id="element-17" />

    <div className="relative z-10 py-4 px-10 md:py-6 md:px-14 flex flex-col gap-0.5 pt-[0px] pb-[3px] pr-[3px] pl-[2px] items-center justify-center" data-id="element-18">
      <span className="md:text-2xl font-bold tracking-wider uppercase font-serif drop-shadow-sm text-[12px]" data-id="element-19">
        QUIERO APRENDER
      </span>
      <span className="text-xs md:text-sm font-medium italic opacity-90 lowercase font-serif" data-id="element-20">
        y acceder ahora
      </span>
    </div>

    {/* Subtle glow on hover */}
    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-white/10 blur-xl pointer-events-none" data-id="element-21" />
  </motion.button>;
const CTAButton = ({
  onClick,
  className = ''
}: {
  onClick: () => void;
  className?: string;
}) => <button onClick={onClick} className={`w-full max-w-2xl mx-auto text-white font-black py-10 rounded-[2.5rem] shadow-2xl hover:bg-[#1F3A22] active:scale-[0.98] transition-all flex uppercase mb-6 animate-slow-pulse flex-col items-center justify-center text-[28px] bg-[#32B742] gap-[16px] pt-[10px] pb-[10px] ${className}`} data-id="element-22">
    ¡SÍ, LO QUIERO!
  </button>;
// --- Components ---
const StickyHeader = ({
  onAction,
  showPurchase,
  currentMessage
}: {
  onAction: () => void;
  showPurchase: boolean;
  currentMessage: string;
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    if (latest > 400) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  });
  return <AnimatePresence data-id="element-23">
      {isVisible && <motion.div initial={{
      y: -100
    }} animate={{
      y: 0
    }} exit={{
      y: -100
    }} className="fixed top-0 left-0 right-0 z-[100] bg-white/90 backdrop-blur-md border-b border-[#2F5233]/10 py-2 px-4 sm:px-6 shadow-lg flex items-center justify-between gap-4" data-id="element-24">
          <div className="flex-1 flex items-center min-w-0" data-id="element-25">
            <TopBarActivity showPurchase={showPurchase} currentMessage={currentMessage} data-id="element-26" />
          </div>
          <div className="flex shrink-0 items-center" data-id="element-27">
            <button onClick={onAction} className="bg-[#E07A5F] text-white px-4 sm:px-6 py-2 rounded-full font-black uppercase shadow-md hover:bg-[#D1694E] transition-all active:scale-95 text-[10px] sm:text-[12px] whitespace-nowrap" data-id="element-28">
              VER OFERTA
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
};
const ScrollReveal = ({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 40
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 1.2,
  delay,
  ease: [0.21, 0.47, 0.32, 0.98]
}} data-id="element-29">
    {children}
  </motion.div>;
const CommentSection = () => {
  const AVATAR_COLORS = ['from-[#2F5233] to-[#4A7856]', 'from-[#E07A5F] to-[#D1694E]', 'from-[#9FD9D3] to-[#6BC4B8]', 'from-[#8D7B6D] to-[#A69484]', 'from-[#D4AF37] to-[#C49B2A]', 'from-[#B56576] to-[#9E4F5E]', 'from-[#6D597A] to-[#5B4868]', 'from-[#355070] to-[#2A4059]'];
  const AVATAR_EMOJIS = ['🧶', '🪡', '🧵', '🌸', '🌿', '💐', '🎀', '🦋', '🌻', '🐰', '🧸', '✨', '💜', '🌺', '🍀', '🎨', '🪻', '🐱', '🌷', '🫧'];
  const [comments, setComments] = useState([{
    id: 1,
    user: 'Norma Beatriz',
    avatar: 'NB',
    emoji: '🧶',
    colorIdx: 0,
    date: 'hace 2 horas',
    rating: 5,
    text: '¡Increíble la calidad de los moldes! Por fin entiendo cómo cerrar bien los puntos. ¡Muy recomendado para todas las que amamos la costura!',
    likes: 24,
    isLiked: false
  }, {
    id: 2,
    user: 'Graciela M.',
    avatar: 'GM',
    emoji: '🪡',
    colorIdx: 1,
    date: 'hace 4 horas',
    rating: 5,
    text: 'Los proyectos de costura son un sueño. Ya terminé mi primer vestido para mi nieta y quedó precioso. Las explicaciones son clarísimas.',
    likes: 18,
    isLiked: false
  }, {
    id: 3,
    user: 'Marta Silvia',
    avatar: 'MS',
    emoji: '🌸',
    colorIdx: 2,
    date: 'hace 5 horas',
    rating: 5,
    text: 'Muy completo todo el material de costura. Me encanta la paciencia con la que enseñan en los videos. ¡Gracias Alma Textil!',
    likes: 12,
    isLiked: false
  }, {
    id: 4,
    user: 'Elena R.',
    avatar: 'ER',
    emoji: '🧵',
    colorIdx: 3,
    date: 'hace 1 día',
    rating: 5,
    text: 'Los patrones son muy fáciles de seguir, valió la pena la inversión. Ya estoy empezando mi tercer proyecto de costura creativa.',
    likes: 9,
    isLiked: false
  }, {
    id: 5,
    user: 'Patricia G.',
    avatar: 'PG',
    emoji: '🌿',
    colorIdx: 4,
    date: 'hace 1 día',
    rating: 5,
    text: 'Excelente atención y los moldes llegan al instante. Los diseños de costura son muy originales y modernos.',
    likes: 15,
    isLiked: false
  }, {
    id: 6,
    user: 'Rosa Inés',
    avatar: 'RI',
    emoji: '💐',
    colorIdx: 5,
    date: 'hace 2 días',
    rating: 5,
    text: 'Me encantaron los bonos de costura, especialmente el de las flores de tela. Muy bien explicado todo el proceso.',
    likes: 7,
    isLiked: false
  }, {
    id: 7,
    user: 'Mirta Beatriz',
    avatar: 'MB',
    emoji: '🎀',
    colorIdx: 6,
    date: 'hace 2 días',
    rating: 5,
    text: 'Por fin encontré patrones de costura que se entienden de verdad. ¡Gracias por compartir su talento con nosotras!',
    likes: 21,
    isLiked: false
  }, {
    id: 8,
    user: 'Alicia S.',
    avatar: 'AS',
    emoji: '🦋',
    colorIdx: 7,
    date: 'hace 3 días',
    rating: 5,
    text: 'El grupo de apoyo para las alumnas de costura es genial. Siempre hay alguien para sacarte las dudas sobre las telas.',
    likes: 11,
    isLiked: false
  }, {
    id: 9,
    user: 'Susana T.',
    avatar: 'ST',
    emoji: '🌻',
    colorIdx: 0,
    date: 'hace 3 días',
    rating: 5,
    text: 'La biblioteca de moldes es inmensa, hay para todos los niveles de costura. Muy conforme con la compra.',
    likes: 14,
    isLiked: false
  }, {
    id: 10,
    user: 'Gladys R.',
    avatar: 'GR',
    emoji: '🐰',
    colorIdx: 1,
    date: 'hace 4 días',
    rating: 5,
    text: 'Ya hice tres mantas con las técnicas de costura del curso. Los acabados quedan súper profesionales.',
    likes: 19,
    isLiked: false
  }, {
    id: 11,
    user: 'Juana P.',
    avatar: 'JP',
    emoji: '🧸',
    colorIdx: 2,
    date: 'hace 4 días',
    rating: 5,
    text: 'Muy buenos los videos explicativos de costura que vienen de regalo. Ayudan mucho a perderle el miedo a la máquina.',
    likes: 8,
    isLiked: false
  }, {
    id: 12,
    user: 'Beatriz L.',
    avatar: 'BL',
    emoji: '✨',
    colorIdx: 3,
    date: 'hace 5 días',
    rating: 5,
    text: 'Es la mejor inversión que hice este año para mi hobby de la costura. ¡Sigan así, enseñando con tanto amor!',
    likes: 25,
    isLiked: false
  }, {
    id: 13,
    user: 'Silvia N.',
    avatar: 'SN',
    emoji: '💜',
    colorIdx: 4,
    date: 'hace 5 días',
    rating: 5,
    text: 'Los patrones de ropa son tendencia total. Me hice un cárdigan que todos me elogian. ¡Gracias Alma Textil!',
    likes: 16,
    isLiked: false
  }, {
    id: 14,
    user: 'Margarita F.',
    avatar: 'MF',
    emoji: '🌺',
    colorIdx: 5,
    date: 'hace 6 días',
    rating: 5,
    text: 'Todo perfecto, desde el pago hasta la descarga de los moldes de costura. Muy profesionales en todo.',
    likes: 13,
    isLiked: false
  }, {
    id: 15,
    user: 'Cristina D.',
    avatar: 'CD',
    emoji: '🍀',
    colorIdx: 6,
    date: 'hace 6 días',
    rating: 5,
    text: 'Me encanta que los patrones de costura vengan con gráficos tan claros. Facilita mucho el trabajo en el taller.',
    likes: 17,
    isLiked: false
  }, {
    id: 16,
    user: 'Zulma T.',
    avatar: 'ZT',
    emoji: '🎨',
    colorIdx: 7,
    date: 'hace 1 semana',
    rating: 5,
    text: 'Muy lindo todo el contenido de costura. El set de cocina es lo más vendido en mi emprendimiento textil.',
    likes: 10,
    isLiked: false
  }, {
    id: 17,
    user: 'Olga B.',
    avatar: 'OB',
    emoji: '🪻',
    colorIdx: 0,
    date: 'hace 1 semana',
    rating: 5,
    text: 'Gracias por los consejos de costura para principiantes. Me ayudaron a perder el miedo y empezar a crear.',
    likes: 22,
    isLiked: false
  }, {
    id: 18,
    user: 'Nélida G.',
    avatar: 'NG',
    emoji: '🐱',
    colorIdx: 1,
    date: 'hace 1 semana',
    rating: 5,
    text: 'Los proyectos de costura para niños son los más tiernos que vi. ¡Mis nietos están felices con sus prendas nuevas!',
    likes: 20,
    isLiked: false
  }, {
    id: 19,
    user: 'Inés S.',
    avatar: 'IS',
    emoji: '🌷',
    colorIdx: 2,
    date: 'hace 2 semanas',
    rating: 5,
    text: 'Excelente material de costura. Se nota que hay mucho trabajo y amor detrás de cada patrón.',
    likes: 18,
    isLiked: false
  }, {
    id: 20,
    user: 'Raquel M.',
    avatar: 'RM',
    emoji: '🫧',
    colorIdx: 3,
    date: 'hace 2 semanas',
    rating: 5,
    text: 'Súper completo el curso de costura. No me canso de descubrir nuevos proyectos para hacer cada fin de semana.',
    likes: 23,
    isLiked: false
  }, {
    id: 21,
    user: 'Carmen J.',
    avatar: 'CJ',
    emoji: '🧵',
    colorIdx: 4,
    date: 'hace 2 semanas',
    rating: 5,
    text: 'Aprendí técnicas de costura que no conocía y que me ahorran mucho tiempo. ¡Totalmente recomendado!',
    likes: 14,
    isLiked: false
  }, {
    id: 22,
    user: 'Lucía P.',
    avatar: 'LP',
    emoji: '✨',
    colorIdx: 5,
    date: 'hace 3 semanas',
    rating: 5,
    text: 'La calidad de los moldes de costura es superior a todo lo que había comprado antes. Calzan perfecto.',
    likes: 19,
    isLiked: false
  }, {
    id: 23,
    user: 'Marta R.',
    avatar: 'MR',
    emoji: '🌸',
    colorIdx: 6,
    date: 'hace 3 semanas',
    rating: 5,
    text: 'Gracias a Alma Textil por fin me animé a coser mi propia ropa. Las clases son una delicia.',
    likes: 11,
    isLiked: false
  }, {
    id: 24,
    user: 'Sofía L.',
    avatar: 'SL',
    emoji: '🎀',
    colorIdx: 7,
    date: 'hace 1 mes',
    rating: 5,
    text: 'Me encantó el módulo de costura para el hogar. Mi casa ahora luce mucho más acogedora con mis creaciones.',
    likes: 16,
    isLiked: false
  }, {
    id: 25,
    user: 'Beatriz H.',
    avatar: 'BH',
    emoji: '🪡',
    colorIdx: 0,
    date: 'hace 1 mes',
    rating: 5,
    text: 'La pedagogía es excelente. Explican cada paso de la costura de forma que es imposible no aprender.',
    likes: 22,
    isLiked: false
  }, {
    id: 26,
    user: 'Graciela F.',
    avatar: 'GF',
    emoji: '🧶',
    colorIdx: 1,
    date: 'hace 1 mes',
    rating: 5,
    text: 'El curso de costura creativa me devolvió las ganas de sentarme frente a la máquina. ¡Muchas gracias!',
    likes: 13,
    isLiked: false
  }, {
    id: 27,
    user: 'Elena M.',
    avatar: 'EM',
    emoji: '🌿',
    colorIdx: 2,
    date: 'hace 1 mes',
    rating: 5,
    text: 'Los moldes de costura son muy variados y modernos. Hay proyectos para todos los gustos y edades.',
    likes: 25,
    isLiked: false
  }, {
    id: 28,
    user: 'Patricia S.',
    avatar: 'PS',
    emoji: '🦋',
    colorIdx: 3,
    date: 'hace 2 meses',
    rating: 5,
    text: 'Excelente inversión para las que amamos la costura. El material es de primera calidad y muy completo.',
    likes: 17,
    isLiked: false
  }, {
    id: 29,
    user: 'Rosa V.',
    avatar: 'RV',
    emoji: '💐',
    colorIdx: 4,
    date: 'hace 2 meses',
    rating: 5,
    text: 'Aprendí a coser cierres y cuellos de forma impecable. Mis prendas ahora parecen compradas en boutique.',
    likes: 10,
    isLiked: false
  }, {
    id: 30,
    user: 'Mirta C.',
    avatar: 'MC',
    emoji: '🌻',
    colorIdx: 5,
    date: 'hace 2 meses',
    rating: 5,
    text: 'El curso de costura desde cero es ideal para las que empezamos tarde pero con muchas ganas. ¡Gracias!',
    likes: 21,
    isLiked: false
  }, {
    id: 31,
    user: 'Alicia D.',
    avatar: 'AD',
    emoji: '🧸',
    colorIdx: 6,
    date: 'hace 2 meses',
    rating: 5,
    text: 'Los proyectos de costura para bebés son una ternura. Ya hice varios sets para regalar a mis amigas.',
    likes: 15,
    isLiked: false
  }, {
    id: 32,
    user: 'Susana L.',
    avatar: 'SL',
    emoji: '✨',
    colorIdx: 7,
    date: 'hace 3 meses',
    rating: 5,
    text: 'La biblioteca de moldes de costura es una joya. Siempre encuentro lo que busco para mis proyectos.',
    likes: 19,
    isLiked: false
  }, {
    id: 33,
    user: 'Gladys M.',
    avatar: 'GM',
    emoji: '💜',
    colorIdx: 0,
    date: 'hace 3 meses',
    rating: 5,
    text: 'Me encanta la forma en que explican la costura. Es muy ameno y se aprende sin darte cuenta.',
    likes: 12,
    isLiked: false
  }, {
    id: 34,
    user: 'Juana R.',
    avatar: 'JR',
    emoji: '🌺',
    colorIdx: 1,
    date: 'hace 3 meses',
    rating: 5,
    text: 'Los moldes de costura para imprimir son súper prácticos. Ahorro mucho tiempo y dinero con ellos.',
    likes: 24,
    isLiked: false
  }, {
    id: 35,
    user: 'Beatriz S.',
    avatar: 'BS',
    emoji: '🍀',
    colorIdx: 2,
    date: 'hace 3 meses',
    rating: 5,
    text: 'Excelente curso de costura, muy completo y bien estructurado. Las clases son de gran ayuda.',
    likes: 16,
    isLiked: false
  }, {
    id: 36,
    user: 'Silvia G.',
    avatar: 'SG',
    emoji: '🎨',
    colorIdx: 3,
    date: 'hace 4 meses',
    rating: 5,
    text: 'Aprendí técnicas de costura que no encontraba en ningún otro lado. ¡Muy satisfecha con la compra!',
    likes: 20,
    isLiked: false
  }, {
    id: 37,
    user: 'Margarita P.',
    avatar: 'MP',
    emoji: '🪻',
    colorIdx: 4,
    date: 'hace 4 meses',
    rating: 5,
    text: 'Los patrones de costura son muy modernos y se adaptan a todos los cuerpos. ¡Me encantan!',
    likes: 14,
    isLiked: false
  }, {
    id: 38,
    user: 'Cristina R.',
    avatar: 'CR',
    emoji: '🐱',
    colorIdx: 5,
    date: 'hace 4 meses',
    rating: 5,
    text: 'Gracias por los bonos de costura, son el complemento perfecto para el curso principal.',
    likes: 23,
    isLiked: false
  }, {
    id: 39,
    user: 'Zulma L.',
    avatar: 'ZL',
    emoji: '🌷',
    colorIdx: 6,
    date: 'hace 4 meses',
    rating: 5,
    text: 'El curso de costura me ayudó a relajarme y encontrar un nuevo hobby que me apasiona.',
    likes: 11,
    isLiked: false
  }, {
    id: 40,
    user: 'Olga S.',
    avatar: 'OS',
    emoji: '🫧',
    colorIdx: 7,
    date: 'hace 5 meses',
    rating: 5,
    text: 'Los moldes de costura son muy claros y fáciles de armar. Los resultados son espectaculares.',
    likes: 18,
    isLiked: false
  }, {
    id: 41,
    user: 'Nélida M.',
    avatar: 'NM',
    emoji: '🧵',
    colorIdx: 0,
    date: 'hace 5 meses',
    rating: 5,
    text: 'Aprendí a coser con acabados profesionales. Ahora mis prendas lucen impecables por dentro y por fuera.',
    likes: 25,
    isLiked: false
  }, {
    id: 42,
    user: 'Inés G.',
    avatar: 'IG',
    emoji: '✨',
    colorIdx: 1,
    date: 'hace 5 meses',
    rating: 5,
    text: 'Excelente material de costura para todas las que queremos emprender desde casa. ¡Muchas gracias!',
    likes: 17,
    isLiked: false
  }, {
    id: 43,
    user: 'Raquel P.',
    avatar: 'RP',
    emoji: '🌸',
    colorIdx: 2,
    date: 'hace 5 meses',
    rating: 5,
    text: 'Los moldes de costura para accesorios son geniales. Ya hice varios bolsos y neceseres preciosos.',
    likes: 10,
    isLiked: false
  }, {
    id: 44,
    user: 'Carmen S.',
    avatar: 'CS',
    emoji: '🎀',
    colorIdx: 3,
    date: 'hace 6 meses',
    rating: 5,
    text: 'Me encanta la comunidad de costura que se formó. Siempre hay alguien dispuesta a ayudar.',
    likes: 21,
    isLiked: false
  }, {
    id: 45,
    user: 'Lucía R.',
    avatar: 'LR',
    emoji: '🪡',
    colorIdx: 4,
    date: 'hace 6 meses',
    rating: 5,
    text: 'El curso de costura es muy completo y fácil de seguir. Las clases en video son una maravilla.',
    likes: 15,
    isLiked: false
  }, {
    id: 46,
    user: 'Marta T.',
    avatar: 'MT',
    emoji: '🧶',
    colorIdx: 5,
    date: 'hace 6 meses',
    rating: 5,
    text: 'Gracias a Alma Textil por fin entiendo los secretos de la costura. ¡Estoy muy feliz con mis avances!',
    likes: 19,
    isLiked: false
  }, {
    id: 47,
    user: 'Sofía M.',
    avatar: 'SM',
    emoji: '🌿',
    colorIdx: 6,
    date: 'hace 6 meses',
    rating: 5,
    text: 'Los moldes de costura para ropa de cama son preciosos. Mi dormitorio ahora luce renovado.',
    likes: 12,
    isLiked: false
  }, {
    id: 48,
    user: 'Beatriz G.',
    avatar: 'BG',
    emoji: '🦋',
    colorIdx: 7,
    date: 'hace 7 meses',
    rating: 5,
    text: 'Excelente inversión en costura creativa. El material es muy variado y siempre hay algo nuevo que aprender.',
    likes: 24,
    isLiked: false
  }, {
    id: 49,
    user: 'Graciela L.',
    avatar: 'GL',
    emoji: '💐',
    colorIdx: 0,
    date: 'hace 7 meses',
    rating: 5,
    text: 'Aprendí a coser con telas difíciles gracias a los tips del curso. ¡Muy agradecida por todo!',
    likes: 16,
    isLiked: false
  }, {
    id: 50,
    user: 'Elena S.',
    avatar: 'ES',
    emoji: '🌻',
    colorIdx: 1,
    date: 'hace 7 meses',
    rating: 5,
    text: 'El curso de costura superó mis expectativas. Es muy completo y las explicaciones son impecables.',
    likes: 20,
    isLiked: false
  }, {
    id: 51,
    user: 'Patricia R.',
    avatar: 'PR',
    emoji: '🧸',
    colorIdx: 2,
    date: 'hace 8 meses',
    rating: 5,
    text: 'Gracias por compartir sus conocimientos de costura de forma tan generosa. ¡Me encanta el curso!',
    likes: 14,
    isLiked: false
  }, {
    id: 52,
    user: 'Rosa M.',
    avatar: 'RM',
    emoji: '✨',
    colorIdx: 3,
    date: 'hace 8 meses',
    rating: 5,
    text: 'Los moldes de costura son una maravilla. Fáciles de usar y con resultados profesionales. ¡Recomendado!',
    likes: 23,
    isLiked: false
  }]);
  const [newComment, setNewComment] = useState('');
  const [rating, setRating] = useState(5);
  const [showThanks, setShowThanks] = useState(false);
  const [visibleCount, setVisibleCount] = useState(5);
  const handlePublish = () => {
    if (!newComment.trim()) return;
    const randomIdx = Math.floor(Math.random() * AVATAR_EMOJIS.length);
    const comment = {
      id: Date.now(),
      user: 'Usuario',
      avatar: 'U',
      emoji: AVATAR_EMOJIS[randomIdx],
      colorIdx: randomIdx % AVATAR_COLORS.length,
      date: 'ahora mismo',
      rating,
      text: newComment,
      likes: 0,
      isLiked: false
    };
    setComments([comment, ...comments]);
    setNewComment('');
    setRating(5);
    setShowThanks(true);
  };
  const toggleLike = (id: number) => {
    setComments(comments.map(c => {
      if (c.id === id) {
        return {
          ...c,
          isLiked: !c.isLiked,
          likes: c.isLiked ? c.likes - 1 : c.likes + 1
        };
      }
      return c;
    }));
  };
  return <ScrollReveal data-id="element-30">
      <div className="max-w-4xl mx-auto p-6 bg-white/40 backdrop-blur-sm rounded-[3rem] border border-[#2F5233]/10 shadow-sm pt-[24px] pb-[24px] mt-[20px] space-y-[16px]" data-id="element-31">
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-4" data-id="element-32">
          <h3 className="text-3xl font-bold flex items-center gap-3 text-[#2F5233] font-serif" data-id="element-33">
            <MessageCircle className="text-[#E07A5F] w-8 h-8" data-id="element-34" /> Comunidad y
            Feedback
          </h3>
          <div className="flex items-center gap-2 bg-[#2F5233]/5 px-4 py-2 rounded-full border border-[#2F5233]/10" data-id="element-35">
            <div className="flex gap-0.5" data-id="element-36">
              {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 fill-[#E07A5F] text-[#E07A5F]" data-id="element-37" />)}
            </div>
            <span className="text-sm font-bold text-[#2F5233]" data-id="element-38">
              4.9/5 Promedio
            </span>
          </div>
        </div>

        <div className="mb-12 space-y-6 bg-white/60 p-8 rounded-[2.5rem] border border-[#2F5233]/5 shadow-inner" data-id="element-39">
          <div className="flex flex-col gap-4" data-id="element-40">
            <p className="text-sm font-bold text-[#8D7B6D] uppercase tracking-wider" data-id="element-41">
              Tu Calificación:
            </p>
            <div className="flex gap-2" data-id="element-42">
              {[1, 2, 3, 4, 5].map(s => <motion.button key={s} whileHover={{
              scale: 1.2
            }} whileTap={{
              scale: 0.9
            }} onClick={() => setRating(s)} data-id="element-43">
                  <Star className={`w-8 h-8 transition-colors ${s <= rating ? 'fill-[#E07A5F] text-[#E07A5F]' : 'text-[#E07A5F]/20'}`} data-id="element-44" />
                </motion.button>)}
            </div>
          </div>

          <textarea value={newComment} onChange={e => setNewComment(e.target.value)} placeholder="Compartí tu experiencia con la comunidad..." className="w-full bg-white border border-[#2F5233]/10 rounded-2xl p-5 text-[#4A3F35] focus:ring-2 focus:ring-[#2F5233]/20 outline-none transition-all shadow-sm min-h-[120px]" data-id="element-45" />

          <div className="flex flex-wrap items-center justify-end gap-4" data-id="element-46">
            <button onClick={handlePublish} disabled={!newComment.trim()} className="bg-[#2F5233] text-white font-black py-4 px-10 rounded-2xl hover:bg-[#1F3A22] transition-all shadow-lg disabled:opacity-50 disabled:cursor-not-allowed active:scale-95" data-id="element-47">
              Publicar Comentario
            </button>
          </div>
        </div>

        <div className="space-y-4" data-id="element-48">
          <AnimatePresence mode="popLayout" data-id="element-49">
            {comments.slice(0, visibleCount).map(c => <motion.div key={c.id} layout initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} className="bg-white/40 p-4 rounded-2xl border border-[#2F5233]/5 hover:border-[#2F5233]/10 transition-all group" data-id="element-50">
                <div className="flex gap-4" data-id="element-51">
                  <div className={`w-12 h-12 shrink-0 rounded-full flex items-center justify-center shadow-sm border border-white/50 bg-gradient-to-br ${AVATAR_COLORS[c.colorIdx % AVATAR_COLORS.length]}`} data-id="element-52">
                    <span className="text-xl" data-id="element-53">{c.emoji}</span>
                  </div>
                  <div className="flex-1 flex flex-col" data-id="element-54">
                    <div className="flex items-center justify-between mb-2" data-id="element-55">
                      <div className="flex items-center gap-2" data-id="element-56">
                        <div data-id="element-57">
                          <p className="font-bold text-[#2F5233] leading-none text-sm mb-1" data-id="element-58">
                            {c.user}
                          </p>
                          <div className="flex items-center gap-2" data-id="element-59">
                            <div className="flex gap-0.5" data-id="element-60">
                              {Array.from({
                            length: 5
                          }).map((_, i) => <Star key={i} className={`w-2.5 h-2.5 ${i < c.rating ? 'fill-[#E07A5F] text-[#E07A5F]' : 'text-[#E07A5F]/20'}`} data-id="element-61" />)}
                            </div>
                            <span className="text-[9px] text-[#8D7B6D] font-medium" data-id="element-62">
                              • {c.date}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="bg-[#2F5233]/5 px-2 py-0.5 rounded-full flex items-center gap-1" data-id="element-63">
                        <CheckCircle2 className="w-2.5 h-2.5 text-[#2F5233]" data-id="element-64" />
                        <span className="text-[8px] font-bold text-[#2F5233] uppercase" data-id="element-65">
                          Verificada
                        </span>
                      </div>
                    </div>
                    <p className="text-[#4A3F35] text-sm leading-relaxed mb-3 flex-1 italic" data-id="element-66">
                      "{c.text}"
                    </p>
                    <div className="flex items-center justify-between pt-2 border-t border-[#2F5233]/5" data-id="element-67">
                      <button onClick={() => toggleLike(c.id)} className={`flex items-center gap-1.5 px-3 py-1 rounded-full transition-all font-bold text-[11px] ${c.isLiked ? 'bg-[#E07A5F]/10 text-[#E07A5F]' : 'text-[#8D7B6D] hover:bg-[#2F5233]/5'}`} data-id="element-68">
                        <Heart className={`w-3.5 h-3.5 transition-all ${c.isLiked ? 'fill-[#E07A5F]' : ''}`} data-id="element-69" />
                        {c.likes}
                      </button>
                      <button className="text-[10px] font-bold text-[#2F5233]/40 hover:text-[#2F5233] transition-colors" data-id="element-70">
                        Responder
                      </button>
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </AnimatePresence>
        </div>

        {visibleCount < comments.length && <button onClick={() => setVisibleCount(prev => prev + 5)} className="w-full mt-10 py-5 border-2 border-dashed border-[#2F5233]/10 rounded-[2rem] font-black text-[#2F5233] hover:bg-[#2F5233]/5 hover:border-[#2F5233]/20 transition-all uppercase tracking-widest text-sm" data-id="element-71">
            Ver más testimonios de la comunidad
          </button>}

        {showThanks && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/20 backdrop-blur-md p-4" data-id="element-72">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} className="bg-white text-[#4A3F35] p-10 rounded-[3rem] max-w-sm text-center shadow-2xl border border-[#2F5233]/10" data-id="element-73">
              <div className="bg-[#2F5233]/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-74">
                <CheckCircle2 className="text-[#2F5233] w-12 h-12" data-id="element-75" />
              </div>
              <h4 className="text-2xl font-bold mb-3 text-[#2F5233] font-serif" data-id="element-76">
                ¡Gracias por inspirarnos!
              </h4>
              <p className="text-[#8D7B6D] mb-8 leading-relaxed" data-id="element-77">
                Tu proyecto y tu opinión son el motor de esta comunidad.
              </p>
              <button onClick={() => setShowThanks(false)} className="w-full bg-[#2F5233] text-white py-4 rounded-2xl font-black shadow-lg hover:bg-[#1F3A22] transition-colors uppercase tracking-wider" data-id="element-78">
                Cerrar
              </button>
            </motion.div>
          </div>}
      </div>
    </ScrollReveal>;
};
const ProjectCarousel = () => {
  return <div className="w-full overflow-hidden py-8 bg-white/20 backdrop-blur-sm rounded-[3rem] border border-[#2F5233]/10" data-id="element-79">
      <div className="text-center mb-6" data-id="element-80">
        <h3 className="text-3xl font-bold text-[#2F5233] font-serif" data-id="element-81">
          Proyectos Terminados por la Comunidad
        </h3>
        <p className="text-[#8D7B6D]" data-id="element-82">
          Inspirate con lo que vos también vas a lograr
        </p>
      </div>

      <div className="flex relative" data-id="element-83">
        <motion.div className="flex gap-6 px-6" animate={{
        x: [0, -2500]
      }} transition={{
        duration: 40,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-84">
          {[...PROJECTS, ...PROJECTS].map((project, idx) => <div key={idx} className="min-w-[300px] bg-white/60 backdrop-blur-sm rounded-3xl overflow-hidden shadow-md border border-[#2F5233]/5 group" data-id="element-85">
              <div className="h-64 overflow-hidden" data-id="element-86">
                <img src={project.url} alt={project.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-87" />
              </div>
              <div className="p-6" data-id="element-88">
                <h4 className="font-bold text-[#2F5233] mb-2" data-id="element-89">
                  {project.title}
                </h4>
                <p className="text-sm text-[#8D7B6D] italic" data-id="element-90">
                  "{project.comment}"
                </p>
              </div>
            </div>)}
        </motion.div>
      </div>
    </div>;
};
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-[#2F5233]/10 last:border-0" data-id="element-91">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left gap-4 group" data-id="element-92">
        <div className="flex items-center gap-4" data-id="element-93">
          <div className="w-10 h-10 rounded-full bg-[#2F5233]/5 flex items-center justify-center shrink-0 group-hover:bg-[#2F5233]/10 transition-colors" data-id="element-94">
            <HelpCircle className="w-5 h-5 text-[#E07A5F]" data-id="element-95" />
          </div>
          <span className="text-lg font-bold text-[#2F5233] font-serif" data-id="element-96">
            {question}
          </span>
        </div>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-97">
          <ChevronDown className="w-6 h-6 text-[#8D7B6D] mb-[80px]" data-id="element-98" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-99">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-100">
            <p className="pb-6 pl-14 text-[#8D7B6D] leading-relaxed" data-id="element-101">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Cómo recibo el acceso a Alma Textil?',
    answer: 'El acceso es inmediato y digital. Una vez confirmado tu pago, recibirás un correo electrónico con tus credenciales para ingresar a la plataforma donde encontrarás todas las clases, moldes y bonos. Podrás verlos desde tu celular, tablet o computadora.'
  }, {
    question: '¿Por cuánto tiempo tendré acceso al contenido?',
    answer: '¡El acceso es de por vida! Una vez que te unes a la academia, el contenido es tuyo para siempre. Podrás avanzar a tu propio ritmo, repetir las clases las veces que necesites y descargar los moldes cuando quieras.'
  }, {
    question: '¿Necesito tener conocimientos previos de costura?',
    answer: 'Para nada. Alma Textil está diseñado especialmente para guiarte desde cero absoluto. Te enseñaremos desde cómo enhebrar la máquina hasta cómo confeccionar prendas completas, paso a paso y sin prisas.'
  }, {
    question: '¿Los moldes vienen en diferentes tallas?',
    answer: '¡Sí! El Bono de Atelier de Creación incluye más de 2000 moldes profesionales escalados en diferentes tallas, listos para imprimir en casa y comenzar a cortar tus telas con total seguridad.'
  }, {
    question: '¿Me sirve si quiero empezar a vender lo que coso?',
    answer: 'Absolutamente. No solo aprenderás a coser con acabados profesionales, sino que el bono "Tu Marca Textil" te dará las herramientas de branding y presentación necesarias para que puedas lanzar tu propio emprendimiento desde casa.'
  }];
  return <ScrollReveal data-id="element-102">
      <section className="max-w-3xl mx-auto px-6 mt-[0px] mb-[0px]" data-id="element-103">
        <div className="text-center mb-6" data-id="element-104">
          <h2 className="text-4xl font-bold text-[#2F5233] font-serif mb-4" data-id="element-105">
            Preguntas Frecuentes
          </h2>
          <p className="text-[#8D7B6D]" data-id="element-106">
            Todo lo que necesitas saber sobre Alma Textil
          </p>
        </div>
        <div className="bg-white/40 backdrop-blur-md rounded-[2.5rem] p-6 border border-[#2F5233]/10 shadow-sm" data-id="element-107">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-108" />)}
        </div>
      </section>
    </ScrollReveal>;
};
const PremiumTrustSection = () => {
  return <div className="mt-8 max-w-4xl mx-auto px-4" data-id="element-109"></div>;
};
const PaymentTrustSection = () => {
  return <div className="payment-trust-section" data-id="element-110">
      <div className="payment-trust-grid" data-id="element-111">
        {/* Primero: Pago seguro garantizado (ancho completo) */}
        <div className="payment-trust-wide" data-id="element-112">
          <img src="https://cdn.magicpatterns.com/uploads/ojx2NapuU4GexKWengor8y/Helado-Artesanal-1.webp" alt="Pago seguro garantizado" data-id="element-113" />
        </div>

        {/* Después: MercadoLíder Platinum y Mercado Pago */}
        <img src="https://cdn.magicpatterns.com/uploads/uPHBx1AMkqdFQPC23V15Wd/MercadoLider-en-Mercado-Libre.webp" alt="MercadoLíder Platinum" data-id="element-114" />
        <img src="https://cdn.magicpatterns.com/uploads/6kFhDvr7ZNWV7qhnVaRup5/pago_mercado_libre.webp" alt="Mercado Pago" data-id="element-115" />

        {/* Abajo: Compra segura y 7 días de garantía */}
        <img src="https://cdn.magicpatterns.com/uploads/wR5p8HoidFGvRX7LaiQyyt/safe-purchase-7779878_1280.webp" alt="Compra segura" data-id="element-116" />
        <img src="https://cdn.magicpatterns.com/uploads/uFnv8haqsZGS2rWBtAKnap/zn9vtwfya.webp" alt="7 días de garantía" data-id="element-117" />
      </div>
    </div>;
};
const UpsellBox = ({
  onSelect
}: {
  onSelect: (option: 'alma' | 'combo') => void;
}) => {
  const [selected, setSelected] = useState<'alma' | 'combo'>('combo');
  const options = {
    alma: {
      label: 'Upsell básico',
      title: 'Alma Textil',
      desc: 'Sistema de costura, moldes y emprendimiento textil',
      price: '$19.990',
      oldPrice: '$39.990',
      img: 'https://cdn.magicpatterns.com/uploads/ooxAwhJCQyqv2cWySiRkZk/ChatGPT_Image_27_may_2026,_21_50_55.webp',
      url: CHECKOUT_LINK,
      includes: ['Sistema Alma Textil completo', 'Bono #1: Atelier de Creación', 'Bono #2: Hogar con Alma', 'Bono #3: Tu Marca Textil', 'Bono #4: Costura desde Cero']
    },
    combo: {
      label: 'Completo',
      title: 'Hilos + Alma Textil',
      desc: 'Te llevás ambos productos principales con todos sus bonos',
      price: '$29.990',
      oldPrice: '$59.990',
      // Modificamos esto a continuación
      popular: true,
      img: 'https://cdn.magicpatterns.com/uploads/f5njvCc7S1UtrCyDHwT9kY/file_00000000bd78720eacd03a406673bb38.png',
      url: COMBO_CHECKOUT_LINK,
      includes: ['Hilos Enamoran + Alma Textil', 'Todos los bonos de Alma Textil', 'Bono #1: La Esencia del Tejido', 'Bono #2: Dulce Compañía', 'Bono #3: Florecer en Hilos', 'Bono #4: Tramas que Acompañan', 'Bono #5: Moda con Alma']
    }
  };
  const handleSelect = (option: 'alma' | 'combo') => {
    setSelected(option);
    onSelect(option);
    // Track offer selection
    // @ts-ignore
    if (window.fbq) {
      // @ts-ignore
      fbq('track', 'AddToCart', {
        content_name: option === 'alma' ? 'Alma Textil' : 'Hilos + Alma Textil',
        value: option === 'alma' ? 19990 : 29990,
        currency: 'ARS'
      });
    }
  };
  const handlePurchase = () => {
    window.location.href = options[selected].url;
  };
  return <div className="upsell-box w-[96%] max-w-[520px] md:max-w-[1200px] mx-auto my-10 p-6 md:p-8 px-[18px] md:px-8 bg-[#fff7f3] rounded-[3rem] border border-[#ead7cf] shadow-sm flex flex-col md:flex-row gap-10 md:gap-16 items-center" data-id="element-118">
      {/* Left side: Image Preview */}
      <div className="upsell-image-box w-full md:w-[60%] text-center overflow-hidden rounded-3xl border border-[#ead7cf]/50 bg-white p-3 shrink-0 shadow-lg" data-id="element-119">
        <AnimatePresence mode="wait" data-id="element-120">
          <motion.img key={selected} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 1.05
        }} transition={{
          duration: 0.3
        }} src={options[selected].img} alt="Oferta seleccionada" id="upsell-image" className="w-full h-auto rounded-[18px] shadow-inner block" data-id="element-121" />
        </AnimatePresence>
      </div>

      {/* Right side: Selection and Purchase */}
      <div className="w-full md:w-[40%] flex flex-col" data-id="element-122">
        <h3 className="mb-6 text-2xl font-bold text-[#4b342c] font-serif" data-id="element-123">
          Elegí tu oferta especial
        </h3>

        <div className="upsell-cards grid grid-cols-2 gap-3 mb-6 w-full" data-id="element-124">
          {/* Card Alma */}
          <div onClick={() => handleSelect('alma')} className={`upsell-card relative border-2 rounded-2xl bg-white cursor-pointer transition-all duration-300 flex flex-col p-4 ${selected === 'alma' ? 'border-[#b87959] shadow-lg -translate-y-1 bg-[#fffaf8]' : 'border-[#ead7cf] opacity-80 hover:opacity-100'}`} data-id="element-125">
            <div className="flex items-center justify-between mb-2" data-id="element-126">
              <span className="text-[10px] font-bold text-[#9b5c3c] uppercase tracking-wider" data-id="element-127">
                Básico
              </span>
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'alma' ? 'border-[#b87959] bg-[#b87959]' : 'border-[#ead7cf]'}`} data-id="element-128">
                {selected === 'alma' && <CheckCircle2 className="w-3.5 h-3.5 text-white" data-id="element-129" />}
              </div>
            </div>
            <h4 className="text-sm md:text-base font-bold text-[#4b342c] mb-2" data-id="element-130">
              {options.alma.title}
            </h4>
            <div className="flex flex-col mb-3" data-id="element-131">
              <span className="text-xs line-through opacity-70 font-medium text-[#E41300]" data-id="element-132">
                {options.alma.oldPrice}
              </span>
              <strong className="text-xl md:text-2xl font-black text-[#b87959]" data-id="element-133">
                {options.alma.price}
              </strong>
            </div>
            <div className="mt-auto" data-id="element-134">
              <div className={`w-full py-2 rounded-xl text-center text-[10px] font-black uppercase tracking-wider transition-all ${selected === 'alma' ? 'bg-[#b87959] text-white shadow-sm' : 'bg-[#ead7cf]/20 text-[#9b5c3c] border border-[#ead7cf]/50'}`} data-id="element-135">
                {selected === 'alma' ? '✓ SELECCIONADO' : 'SELECCIONAR'}
              </div>
            </div>
          </div>

          {/* Card Combo */}
          <div onClick={() => handleSelect('combo')} className={`upsell-card relative border-2 rounded-2xl bg-white cursor-pointer transition-all duration-300 flex flex-col p-4 ${selected === 'combo' ? 'border-[#b87959] shadow-lg -translate-y-1 bg-[#fffaf8]' : 'border-[#ead7cf] opacity-80 hover:opacity-100'}`} data-id="element-136">
            {options.combo.popular && <div className="absolute -top-3 right-4 bg-[#FFD700] text-[#4b342c] px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-tighter shadow-md z-10 border border-[#DAA520]/30" data-id="element-137">
                ★ MÁS PEDIDO
              </div>}
            <div className="flex items-center justify-between mb-2" data-id="element-138">
              <span className="text-[10px] font-bold text-[#9b5c3c] uppercase tracking-wider" data-id="element-139">
                {options.combo.label}
              </span>
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'combo' ? 'border-[#b87959] bg-[#b87959]' : 'border-[#ead7cf]'}`} data-id="element-140">
                {selected === 'combo' && <CheckCircle2 className="w-3.5 h-3.5 text-white" data-id="element-141" />}
              </div>
            </div>
            <h4 className="text-sm md:text-base font-bold text-[#4b342c] mb-2" data-id="element-142">
              {options.combo.title}
            </h4>
            <div className="flex flex-col mb-3" data-id="element-143">
              <span className="text-xs line-through opacity-70 font-medium text-[#E5412C]" data-id="element-144">
                {options.combo.oldPrice}
              </span>
              <strong className="text-xl md:text-2xl font-black text-[#b87959]" data-id="element-145">
                {options.combo.price}
              </strong>
            </div>
            <div className="mt-auto" data-id="element-146">
              <div className={`w-full py-2 rounded-xl text-center text-[10px] font-black uppercase tracking-wider transition-all ${selected === 'combo' ? 'bg-[#b87959] text-white shadow-sm' : 'bg-[#ead7cf]/20 text-[#9b5c3c] border border-[#ead7cf]/50'}`} data-id="element-147">
                {selected === 'combo' ? '✓ SELECCIONADO' : 'SELECCIONAR'}
              </div>
            </div>
          </div>
        </div>

        {/* Inclusion Details */}
        <div className="mb-10 bg-white/60 rounded-[2rem] p-6 md:p-8 border border-[#ead7cf]/50 shadow-inner" data-id="element-148">
          <p className="text-xs font-bold text-[#9b5c3c] uppercase tracking-widest mb-5" data-id="element-149">
            ¿Qué incluye tu acceso inmediato?
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3" data-id="element-150">
            <AnimatePresence mode="wait" data-id="element-151">
              <motion.div key={selected} initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: 10
            }} transition={{
              duration: 0.2
            }} data-id="element-152">
                {options[selected].includes.map((item, idx) => <li key={idx} className="flex items-start gap-2 text-xs text-[#6d5a52]" data-id="element-153">
                    <CheckCircle2 className="w-3.5 h-3.5 text-[#32B742] shrink-0 mt-0.5" data-id="element-154" />
                    <span data-id="element-155">{item}</span>
                  </li>)}
              </motion.div>
            </AnimatePresence>
          </ul>
        </div>

        <button onClick={handlePurchase} className="w-full bg-[#32B742] hover:bg-[#28a736] text-white font-black py-6 md:py-8 rounded-[2rem] shadow-2xl transition-all active:scale-[0.98] animate-slow-pulse flex pt-[10px] pb-[10px] mb-[0px] gap-[4px] flex-col items-center justify-center" data-id="element-156">
          <span className="text-xl md:text-2xl uppercase tracking-wider" data-id="element-157">
            ACCEDER AHORA
          </span>
          <AnimatePresence mode="wait" data-id="element-158"></AnimatePresence>
        </button>
      </div>
    </div>;
};
const FloatingBackground = () => {
  const elements = [{
    icon: Scissors,
    size: 24,
    color: '#D4AF37',
    blur: 'blur-[1px]'
  }, {
    icon: Ruler,
    size: 20,
    color: '#8D7B6D',
    blur: 'blur-[2px]'
  }, {
    icon: Wind,
    size: 28,
    color: '#E07A5F',
    blur: 'blur-[0px]'
  }, {
    icon: Flower2,
    size: 32,
    color: '#FADADD',
    blur: 'blur-[3px]'
  }, {
    icon: Circle,
    size: 12,
    color: '#D4AF37',
    blur: 'blur-[1px]'
  }, {
    icon: Scissors,
    size: 18,
    color: '#8D7B6D',
    blur: 'blur-[4px]'
  }, {
    icon: Wind,
    size: 22,
    color: '#FADADD',
    blur: 'blur-[1px]'
  }, {
    icon: Flower2,
    size: 24,
    color: '#E07A5F',
    blur: 'blur-[2px]'
  }, {
    icon: Ruler,
    size: 16,
    color: '#D4AF37',
    blur: 'blur-[0px]'
  }, {
    icon: Circle,
    size: 10,
    color: '#8D7B6D',
    blur: 'blur-[2px]'
  }];
  return <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" data-id="element-159">
      {elements.map((el, i) => <motion.div key={i} className={`absolute ${el.blur} opacity-[0.15]`} initial={{
      x: Math.random() * 100 + '%',
      y: Math.random() * 100 + '%',
      rotate: Math.random() * 360
    }} animate={{
      x: [Math.random() * 100 + '%', Math.random() * 100 + '%', Math.random() * 100 + '%'],
      y: [Math.random() * 100 + '%', Math.random() * 100 + '%', Math.random() * 100 + '%'],
      rotate: [0, 180, 360]
    }} transition={{
      duration: 40 + Math.random() * 40,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-160">
          <el.icon size={el.size} strokeWidth={1} color={el.color} data-id="element-161" />
        </motion.div>)}
    </div>;
};
const App = () => {
  const [showPurchase, setShowPurchase] = useState(false);
  const [currentMessage, setCurrentMessage] = useState('');
  const [selectedOffer, setSelectedOffer] = useState<'completo' | 'alma'>('completo');
  // Helper to track Meta Pixel events
  const trackEvent = (eventName: string, params?: object) => {
    // @ts-ignore
    if (window.fbq) {
      // @ts-ignore
      fbq('track', eventName, params);
    }
  };
  useEffect(() => {
    // Meta Pixel Initialization
    const PIXEL_ID = '1293858232676625';
    // @ts-ignore
    if (!window.fbq) {
      // @ts-ignore
      import('react-facebook-pixel').then(x => x.default).then(ReactPixel => {
        ReactPixel.init(PIXEL_ID);
        ReactPixel.pageView();
      }).catch(() => {
        // Fallback to manual snippet if package is not available
        // @ts-ignore
        !function (f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        // @ts-ignore
        fbq('init', PIXEL_ID);
        // @ts-ignore
        fbq('track', 'PageView');
      });
    } else {
      // @ts-ignore
      fbq('track', 'PageView');
    }
    const generateMessage = () => {
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const city = ARG_CITIES[Math.floor(Math.random() * ARG_CITIES.length)];
      const isPackCompleto = Math.random() < 0.7;
      if (isPackCompleto) {
        const emojis = ['✅', '🛍️', '🔥'];
        const emoji = emojis[Math.floor(Math.random() * emojis.length)];
        return `${emoji} ${name} de ${city} ingresó a Pack Completo`;
      } else {
        const emojis = ['🛍️', '✨'];
        const emoji = emojis[Math.floor(Math.random() * emojis.length)];
        return `${emoji} ${name} de ${city} ingresó a Alma Textil`;
      }
    };
    const triggerActivity = () => {
      setCurrentMessage(generateMessage());
      setShowPurchase(true);
      setTimeout(() => {
        setShowPurchase(false);
      }, 6000);
    };
    const initialTimeout = setTimeout(triggerActivity, 5000);
    const interval = setInterval(triggerActivity, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const scrollToPricing = () => {
    trackEvent('Contact'); // Track interest in pricing
    const el = document.getElementById('pricing');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handlePurchase = () => {
    // @ts-ignore
    if (window.fbq) {
      // @ts-ignore
      fbq('track', 'InitiateCheckout', {
        content_name: selectedOffer === 'completo' ? 'Hilos + Alma Textil' : 'Hilos + Alma Textil',
        value: selectedOffer === 'completo' ? 29990 : 19990,
        currency: 'ARS'
      });
    }
    // In a real app, this would change based on selectedOffer
    window.location.href = CHECKOUT_LINK;
  };
  const [showHookButton, setShowHookButton] = useState(true);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    // Show button when in the top part of the page (hook area)
    if (latest < 800) {
      setShowHookButton(true);
    } else {
      setShowHookButton(false);
    }
  });
  return <div className="min-h-screen selection:bg-[#FADADD] selection:text-[#5D4037]" data-id="element-162">
      <StickyHeader onAction={scrollToPricing} showPurchase={showPurchase} currentMessage={currentMessage} data-id="element-163" />

      {/* Hero Bar */}
      <div className="bg-gradient-to-r from-[#9FD9D3] via-[#B8E2DE] to-[#9FD9D3] border-b border-[#2F5233]/10" data-id="element-164">
        <TopBarActivity showPurchase={showPurchase} currentMessage={currentMessage} data-id="element-165" />
      </div>

      {/* Hero Section */}
      <ScrollReveal data-id="element-166">
        <section className="w-full flex flex-col items-center relative !mt-0 !pt-0" data-id="element-167">
          <div className="w-full overflow-hidden flex flex-col leading-[0] text-[0]" data-id="element-168">
            <div className="relative w-full" data-id="element-169">
              <img src="https://cdn.magicpatterns.com/uploads/mckYRZaexpqMdPtjhbaikU/ChatGPT_Image_29_may_2026,_19_32_51.webp" alt="Alma Textil" className="w-full h-auto block m-0 p-0" data-id="element-170" />
            </div>
          </div>
          <div className="w-full max-w-xl px-6 mt-6 md:mt-10 relative z-10 flex justify-center" data-id="element-171">
            <PremiumCTAButton onClick={scrollToPricing} className="w-full py-6" data-id="element-172" />
          </div>
        </section>
      </ScrollReveal>

      <main className="max-w-5xl mx-auto px-6 py-6 pt-[0px] pb-[0px] pl-[0px] pr-[0px] space-y-[12px]" data-id="element-173">
        {/* CTA Button - Moved below emotional section */}
        <ScrollReveal data-id="element-174">
          <div className="my-8 text-center" data-id="element-175"></div>
        </ScrollReveal>

        <ScrollReveal data-id="element-176">
          <div className="space-y-8" data-id="element-177">
            <h3 className="md:text-5xl font-bold text-[#2F5233] text-center font-serif text-[28px]" data-id="element-178">
              QUÉ VAS A LOGRAR EN ALMA TEXTIL
            </h3>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-179">
              {[{
              title: 'Costura desde cero absoluto',
              desc: 'Aunque nunca hayas enhebrado una aguja, aprenderás las bases reales de la costura. Pierde el miedo a la máquina y avanza con seguridad, paso a paso, en un ambiente de aprendizaje tranquilo y femenino.',
              img: 'https://cdn.magicpatterns.com/uploads/ahM5BtGe6dC6grFtfuxkZk/ChatGPT_Image_27_may_2026,_20_24_22.webp'
            }, {
              title: 'Moldes profesionales sin frustración',
              desc: 'Deja de pelear con tutoriales confusos. Aprenderás a interpretar moldes, cortar la tela correctamente y ensamblar piezas con precisión para que tu ropa calce perfecto desde el primer intento.',
              img: 'https://cdn.magicpatterns.com/uploads/m3CssYiE6dJ21QcpP6648s/ChatGPT_Image_28_may_2026,_09_19_32.webp'
            }, {
              title: 'Crea tu propia ropa y proyectos',
              desc: 'Transforma telas en prendas hermosas, accesorios y decoración para el hogar. Construye algo con tus propias manos, recupera tu libertad creativa y siéntete orgullosa de decir "lo hice yo".',
              img: 'https://cdn.magicpatterns.com/uploads/2SHRWLreg7CwzCvb3JNC7y/ChatGPT_Image_28_may_2026,_09_23_17.webp'
            }, {
              title: 'Inicia tu emprendimiento desde casa',
              desc: 'Convierte tu pasión en ingresos. Te guiaremos no solo en la técnica, sino en cómo crear tu marca, presentar tus productos y construir un negocio textil que te brinde independencia financiera.',
              img: 'https://cdn.magicpatterns.com/uploads/a54aFKpz1MoJHLk1nRSbQM/ChatGPT_Image_27_may_2026,_20_30_54.webp'
            }].map((item, idx) => <motion.div key={idx} whileHover={{
              y: -10
            }} className="bg-white/30 backdrop-blur-md rounded-[3rem] border border-[#2F5233]/10 shadow-sm overflow-hidden flex flex-col" data-id="element-180">
                  <div className="p-4" data-id="element-181">
                    <img src={item.img} alt={item.title} className="w-full h-auto rounded-[2rem] shadow-md" data-id="element-182" />
                  </div>
                  <div className="p-8 pt-4 space-y-4" data-id="element-183">
                    <h4 className="text-2xl font-bold text-[#2F5233] font-serif leading-tight" data-id="element-184">
                      {item.title}
                    </h4>
                    <p className="text-[#4A3F35] leading-relaxed" data-id="element-185">
                      {item.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </ScrollReveal>

        {/* Project Carousel */}
        <ScrollReveal data-id="element-186">
          <ProjectCarousel data-id="element-187" />
        </ScrollReveal>

        {/* Bonuses Section */}
        <section className="mt-12" data-id="element-188">
          <ScrollReveal data-id="element-189">
            <div className="text-center mb-8" data-id="element-190">
              <h3 className="md:text-6xl font-black mb-4 text-[#2F5233] pt-[12px] pb-[12px] text-[32px]" data-id="element-191">
                Y SI TE UNÍS AHORA, RECIBÍS ESTOS{' '}
                <span className="text-[#E07A5F]" data-id="element-192">4 BONOS EXCLUSIVOS</span>:
              </h3>
              <p className="text-[#E07A5F] font-bold animate-pulse text-[16px]" data-id="element-193">
                ¡GRATIS SOLO POR EL DÍA DE HOY!
              </p>
            </div>
          </ScrollReveal>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-194">
            {BONUSES.map((bonus, idx) => <ScrollReveal key={bonus.id} delay={idx * 0.1} data-id="element-195">
                <div className="bg-white/40 backdrop-blur-md rounded-[3rem] overflow-hidden border border-[#2F5233]/10 hover:border-[#2F5233]/30 transition-all group cursor-pointer shadow-sm hover:shadow-xl" onClick={scrollToPricing} data-id="element-196">
                  <div className="aspect-[4/3] overflow-hidden p-4" data-id="element-197">
                    <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover rounded-[2rem] border-4 border-white shadow-md group-hover:scale-105 transition-transform duration-1000 pr-[15px] pl-[22px]" data-id="element-198" />
                  </div>
                  <div className="p-8 pt-2" data-id="element-199">
                    <h4 className="text-xl font-bold mb-3 text-[#2F5233] font-serif" data-id="element-200">
                      {bonus.title}
                    </h4>
                    <p className="text-[#8D7B6D] text-base leading-relaxed mb-6" data-id="element-201">
                      {bonus.desc}
                    </p>
                    <div className="flex items-center justify-between pt-6 border-t border-[#2F5233]/5" data-id="element-202">
                      <span className="text-sm font-bold text-[#8D7B6D] line-through" data-id="element-203">
                        VALOR: $7.998 PESOS
                      </span>
                      <span className="text-xl font-bold text-[#E07A5F]" data-id="element-204">
                        HOY GRATIS
                      </span>
                    </div>
                  </div>
                </div>
              </ScrollReveal>)}
          </div>
        </section>

        {/* Summary Section: What you get */}
        <ScrollReveal data-id="element-205">
          <section className="mt-12 mb-8" data-id="element-206"></section>
        </ScrollReveal>

        {/* Pricing Section */}
        <ScrollReveal data-id="element-207">
          <section id="pricing" className="py-12 relative overflow-hidden pt-[0px] pb-[0px] space-x-[0px] space-y-[0px]" data-id="element-208">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#E07A5F]/5 rounded-full -mr-32 -mt-32 blur-3xl" data-id="element-209" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#2F5233]/5 rounded-full -ml-32 -mb-32 blur-3xl" data-id="element-210" />

            <div className="max-w-6xl mx-auto px-6" data-id="element-211">
              <div className="text-center mb-8 space-y-4" data-id="element-212">
                <h3 className="md:text-5xl font-bold text-[#2F5233] font-serif text-[28px]" data-id="element-213">
                  ELEGÍ TU CAMINO CREATIVO
                </h3>
                <div className="flex flex-wrap items-center justify-center gap-6 text-sm font-bold text-[#2F5233]/60 uppercase tracking-widest" data-id="element-214">
                  <div className="flex items-center gap-2" data-id="element-215">
                    <CheckCircle2 className="w-4 h-4 text-[#E07A5F]" data-id="element-216" />
                    Acceso de por vida
                  </div>
                  <div className="flex items-center gap-2" data-id="element-217">
                    <CheckCircle2 className="w-4 h-4 text-[#E07A5F]" data-id="element-218" />
                    Garantía de 7 días
                  </div>
                  <div className="flex items-center gap-2" data-id="element-219">
                    <CheckCircle2 className="w-4 h-4 text-[#E07A5F]" data-id="element-220" />
                    Soporte prioritario
                  </div>
                </div>
              </div>

              <div className="w-full mx-auto px-0" data-id="element-221">
                <UpsellBox onSelect={setSelectedOffer} data-id="element-222" />
              </div>

              <PaymentTrustSection data-id="element-223" />

              <div className="max-w-6xl mx-auto px-6" data-id="element-224">
                <PremiumTrustSection data-id="element-225" />
              </div>
            </div>
          </section>
        </ScrollReveal>

        {/* Final CTA */}
        <ScrollReveal data-id="element-226">
          <section className="mt-16 text-center pb-10" data-id="element-227">
            <h3 className="text-5xl md:text-7xl font-black mb-6 text-[#2F5233] font-serif leading-tight" data-id="element-228">
              ¿Vas a seguir postergando tu sueño o vas a empezar a crear?
            </h3>
            <p className="text-2xl md:text-3xl text-[#8D7B6D] mb-10 max-w-4xl mx-auto leading-relaxed" data-id="element-229">
              No dejes que tu talento se oxide por miedo a equivocarte o por
              culpa de tutoriales confusos. Recupera tu confianza, domina la
              máquina de coser y construye un futuro creativo desde la comodidad
              de tu hogar.
            </p>
            <button onClick={scrollToPricing} className="bg-[#E07A5F] text-white font-black px-20 py-12 rounded-[3rem] shadow-2xl hover:bg-[#D1694E] active:scale-[0.98] transition-all flex items-center justify-center uppercase mx-auto animate-slow-pulse text-[14px] gap-[24px] pt-[10px] pb-[10px]" data-id="element-230">
              SÍ, QUIERO ENTRAR A ALMA TEXTIL AHORA
            </button>
          </section>
        </ScrollReveal>

        <FAQSection data-id="element-231" />

        <CommentSection data-id="element-232" />
      </main>

      <footer className="bg-white/10 backdrop-blur-sm py-12 border-t border-[#2F5233]/10 text-center text-[#8D7B6D] text-lg" data-id="element-233">
        <ScrollReveal data-id="element-234">
          <p className="mb-4" data-id="element-235">
            © {new Date().getFullYear()} Hilos que Enamoran. Todos los derechos
            reservados.
          </p>
          <p className="max-w-2xl mx-auto opacity-60" data-id="element-236">
            Este sitio no es parte de Facebook ni de Google Inc.
          </p>
        </ScrollReveal>
      </footer>
    </div>;
};
export { App };